import { __ } from "@wordpress/i18n";
import { css } from "@/utils/css";
import { tabs } from "./";
import { useKnowledgeBaseStats } from "@/hooks/use-knowledge-base";
import { IS_PRO, LIMITS } from "@/utils/constants";

type Props = {
    onTabChange?: (tab: string) => void;
};

export function Overview({ onTabChange }: Props) {
    const { data: stats } = useKnowledgeBaseStats();

    return (
        <div className={css("overview")}>
            <h2 className={css("title")}>{__("Knowledge Base", "antimanual")}</h2>
            <p className={css("subtitle")}>
                {__(
                    "Enrich the knowledge of your AI assistant with content from various sources to provide accurate and relevant responses. Choose from the options below to get started.",
                    "antimanual"
                )}
            </p>
            <div className={css("options")}>
                {tabs.slice(1).map((tab) => {
                    const total = stats?.find((stat) => stat.type === tab.value)?.total || 0;
                    let label = total > 0 ? `${tab.label} (${total})` : tab.label;

                    if (!IS_PRO && tab.value === "wp") {
                        label = `${tab.label} (${total}/${LIMITS.KB_WP_POSTS})`;
                    }

                    return (
                        <div className={css("option")} key={tab.value} onClick={() => onTabChange?.(tab.value)}>
                            <div className={css("icon")}>{tab.icon}</div>
                            <h3 className={css("title")}>{label}</h3>
                            <p className={css("description")}>{tab.description}</p>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
